<template>
  <v-container fluid>
    <v-card :color="bgColor" dark v-if="content.found">
      <v-list-item>
        <v-list-item-content class="align-self-start">
          <v-list-item-title
            class="display-1 mb-2"
            v-text="title"
          ></v-list-item-title>
          <v-list-item-subtitle
            v-html="content.description"
          ></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-avatar v-if="!hideImage && content.imgURL" :size="imgSize">
          <v-img :src="content.imgURL"></v-img>
        </v-list-item-avatar>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import { CONTENTS_SEARCH_QUERY } from "../../../constants/graphql";

export default {
  name: "ShowContent",

  props: {
    title: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "#1F7087",
    },
    owner: {
      type: String,
      default: "OTHER",
    },
    contentName: {
      type: String,
      default: "",
    },
    hideImage: {
      type: Boolean,
      default: false,
    },
    imgSize: {
      type: Number,
      default: () => 200,
    },
  },

  computed: {
    content() {
      return this.contents &&
        this.contents.edges &&
        this.contents.edges.length > 0
        ? { ...this.contents.edges[0].node, found: true }
        : {
            description: `Content '${this.contentName}' not found.`,
            found: false,
          };
    },
  },

  apollo: {
    contents: {
      query: CONTENTS_SEARCH_QUERY,
      variables() {
        return {
          filter: {
            name_contains: this.contentName,
            owner: this.owner,
          },
        };
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/shared/ShowContent.vue